export default __webpack_public_path__ + "87bce8ca2b10989822ba007d38bd119e.png";